import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const DEFAULTS = ["Cash", "QRIS", "Card", "Transfer", "Other"];

export default function PaymentMethods({ ev, onSaved }) {
    const [list, setList] = useState(ev.payment_methods || DEFAULTS);
    const [extra, setExtra] = useState("");
    const all = [...new Set([...DEFAULTS, ...list])];
    const save = async (next) => {
        if (!next.length) return toast.error("Keep at least one payment method");
        setList(next);
        try {
            await api.patch(`/pos/events/${ev.id}`, { payment_methods: next });
            onSaved?.();
        } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Could not save"); }
    };
    return (
        <div className="space-y-1.5" data-testid="pos-payment-methods">
            <p className="text-[10px] uppercase tracking-widest text-neutral-500">Payment methods</p>
            <div className="flex flex-wrap gap-1.5">
                {all.map((m) => {
                    const on = list.includes(m);
                    return (
                        <button key={m} onClick={() => save(on ? list.filter((x) => x !== m) : [...list, m])} data-testid={`pos-method-toggle-${m.toLowerCase().replace(/\s+/g, "-")}`}
                            className={`rounded-full border px-3 py-1 text-xs ${on ? "border-sage-dark bg-sage-dark text-white" : "border-mist bg-white text-neutral-500"}`}>{m}</button>
                    );
                })}
                <input value={extra} onChange={(e) => setExtra(e.target.value)} placeholder="Add method" data-testid="pos-method-new"
                    onKeyDown={(e) => { if (e.key === "Enter" && extra.trim()) { save([...list, extra.trim()]); setExtra(""); } }}
                    className="h-7 w-28 rounded-full border border-mist px-3 text-xs outline-none focus:border-sage-dark" />
            </div>
        </div>
    );
}
